/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESUserRegistration' store object.
 * @namespace ACESUserRegistrationSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESUserRegistration';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static createPendingCitizenAccount = state =>
    state[selectors.moduleIdentifier].createPendingCitizenAccount.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingCreatePendingCitizenAccount = state =>
    state[selectors.moduleIdentifier].isFetchingCreatePendingCitizenAccount.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static createPendingCitizenAccountError = state =>
    state[selectors.moduleIdentifier].createPendingCitizenAccountError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static emailPasswordReset = state => state[selectors.moduleIdentifier].emailPasswordReset.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingEmailPasswordReset = state =>
    state[selectors.moduleIdentifier].isFetchingEmailPasswordReset.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static emailPasswordResetError = state =>
    state[selectors.moduleIdentifier].emailPasswordResetError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isEmailVerified = state => state[selectors.moduleIdentifier].isEmailVerified.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingIsEmailVerified = state =>
    state[selectors.moduleIdentifier].isFetchingIsEmailVerified.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isEmailVerifiedError = state =>
    state[selectors.moduleIdentifier].isEmailVerifiedError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static activateEmail = state => state[selectors.moduleIdentifier].activateEmail.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingActivateEmail = state =>
    state[selectors.moduleIdentifier].isFetchingActivateEmail.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static activateEmailError = state => state[selectors.moduleIdentifier].activateEmailError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesActivationLinkEmail = state =>
    state[selectors.moduleIdentifier].postAcesActivationLinkEmail.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingPostAcesActivationLinkEmail = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesActivationLinkEmail.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesActivationLinkEmailError = state =>
    state[selectors.moduleIdentifier].postAcesActivationLinkEmailError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesActivateCitizenAccount = state =>
    state[selectors.moduleIdentifier].postAcesActivateCitizenAccount.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingPostAcesActivateCitizenAccount = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesActivateCitizenAccount.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesActivateCitizenAccountError = state =>
    state[selectors.moduleIdentifier].postAcesActivateCitizenAccountError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesResendActivationLinkEmail = state =>
    state[selectors.moduleIdentifier].postAcesResendActivationLinkEmail.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingPostAcesResendActivationLinkEmail = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesResendActivationLinkEmail.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesResendActivationLinkEmailError = state =>
    state[selectors.moduleIdentifier].postAcesResendActivationLinkEmailError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesSendForgotUsernameEmail = state =>
    state[selectors.moduleIdentifier].postAcesSendForgotUsernameEmail.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingPostAcesSendForgotUsernameEmail = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesSendForgotUsernameEmail.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesSendForgotUsernameEmailError = state =>
    state[selectors.moduleIdentifier].postAcesSendForgotUsernameEmailError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesAccountUnlock = state =>
    state[selectors.moduleIdentifier].postAcesAccountUnlock.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingPostAcesAccountUnlock = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesAccountUnlock.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesAccountUnlockError = state =>
    state[selectors.moduleIdentifier].postAcesAccountUnlockError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesCheckAccountEnable = state =>
    state[selectors.moduleIdentifier].postAcesCheckAccountEnable.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingPostAcesCheckAccountEnable = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesCheckAccountEnable.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesCheckAccountEnableError = state =>
    state[selectors.moduleIdentifier].postAcesCheckAccountEnableError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesSendAccountUnlockEmail = state =>
    state[selectors.moduleIdentifier].postAcesSendAccountUnlockEmail.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static isFetchingPostAcesSendAccountUnlockEmail = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesSendAccountUnlockEmail.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserRegistrationSelectors
   */
  static postAcesSendAccountUnlockEmailError = state =>
    state[selectors.moduleIdentifier].postAcesSendAccountUnlockEmailError.payload;
}
